<mat-card>
    <mat-card-title class="font-weight-bold caption-color">Net Sale Price Details</mat-card-title>
    <mat-divider></mat-divider>
    <mat-card-content class="pt-2">

        <div class="row">

           
          

            <div class="col-sm-6" *ngIf="!IsRental">
                <div class="form-group row text-left">
                    <label for="lblBuyBack" class="col-sm-4 col-form-label">BuyBack</label>
                    <div class="col-sm-8">
                        <input class="form-control " type="number" name="txtBuyBack" [(ngModel)]="SpraNetSalePriceRealisedParams.BuyBack">
                    </div>

                </div>
            </div>

            <div class="col-sm-6" *ngIf="!IsRental">
                <div class="form-group row text-left">
                    <label for="lblBuyBackRemarks" class="col-sm-4 col-form-label">Buy Back Remarks
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control " name="txtBuyBackRemarks" [(ngModel)]="SpraNetSalePriceRealisedParams.BuyBackRemarks">
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-sm-6" *ngIf="!IsRental">
                <div class="form-group row text-left">
                    <label for="lblReSaleValueBuyBack" class="col-sm-4 col-form-label">Resale value Of Buyback
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control " type="number" name="txtReSaleValueBuyBack" [(ngModel)]="SpraNetSalePriceRealisedParams.ReSaleValueBuyBack">
                        </div>

                    </div>
                </div>
            </div>

          
           

         

            <div class="col-sm-6" *ngIf="!IsRental">
                <div class="form-group row text-left">
                    <label for="lblRebateWoGST" class="col-sm-4 col-form-label">Rebate W/O GST
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control " type="number" name="txtRebateWoGST" [(ngModel)]="SpraNetSalePriceRealisedParams.RebateWoGST">
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-sm-6" *ngIf="!IsRental">
                <div class="form-group row text-left">
                    <label for="lblBoughtOutItems" class="col-sm-4 col-form-label">Bought Out Items
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control " type="number" name="txtBoughtOutItems" [(ngModel)]="SpraNetSalePriceRealisedParams.BoughtOutItems">
                        </div>

                    </div>
                </div>
            </div>

            <div class="col-sm-6" *ngIf="!IsRental">
                <div class="form-group row text-left">
                    <label for="lblBoughtOutItemsRemarks" class="col-sm-4 col-form-label">Bought Out Items Remarks
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control " name="txtBoughtOutItemsRemarks" [(ngModel)]="SpraNetSalePriceRealisedParams.BoughtOutItemsRemarks">
                        </div>

                    </div>
                </div>
            </div>


            <div class="col-sm-6" *ngIf="SaleType=='DD'">
                <div class="form-group row text-left">
                    <label for="lblAgentCommission" class="col-sm-4 col-form-label">Agent Commission
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control" type="number" name="txtAgentCommission" [(ngModel)]="SpraNetSalePriceRealisedParams.AgentCommission">
                        </div>

                    </div>
                </div>
            </div>

            <div class="col-sm-6" *ngIf="SaleType=='DD'">
                <div class="form-group row text-left">
                    <label class="col-sm-4 col-form-label">Installation Commission</label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control " type="number" name="txtInstallationCommission" [(ngModel)]="SpraNetSalePriceRealisedParams.InstallationCommission">
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-sm-6" *ngIf="SaleType=='DL'" >
                <div class="form-group row text-left">
                    <label for="lblDealerCommission" class="col-sm-4 col-form-label">Dealer Commission
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control " type="number" name="txtDealerCommission"  [(ngModel)]="SpraNetSalePriceRealisedParams.DealerCommission">
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-sm-6" *ngIf="SaleType=='DL'">
                <div class="form-group row text-left">
                    <label class="col-sm-4 col-form-label">Dealer</label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <select id="ddlDealer" name="ddlDealer"  (change)="DealerModelChange()" [(ngModel)]="SpraNetSalePriceRealisedParams.PartnerId" class="form-control">
                             <option *ngFor="let pd of PartnerDetailList" value={{pd.partnerId}}>
                               {{pd.partnerName}}{{pd.partnerCode != "" ? (" - "+pd.partnerCode):"" }}      
                           </option>
                           </select>
                        </div>
                    </div>

                </div>
            </div>
          
           

        </div>


        <div class="row" *ngIf="IsRental">

            <div class="col-sm-6">
                <div class="form-group row text-left">
                    <label class="col-sm-4 col-form-label">Free Item </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control " type="number" name="txtFreeItem" [(ngModel)]="SpraNetSalePriceRealisedParams.FreeItem">
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group row text-left">
                    <label class="col-sm-4 col-form-label">Any Other Discount</label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control " type="number" name="txtOtherDiscount" [(ngModel)]="SpraNetSalePriceRealisedParams.OtherDiscount">
                        </div>
                    </div>

                </div>
            </div>
        </div>


    </mat-card-content>
</mat-card>